import ReactDOM from 'react-dom';
import { useIntl } from 'react-intl';
import styled, { createGlobalStyle, css } from 'styled-components';
import { CopyBigSkin, CopyStandardSkin } from '../Copytext/CopytextSkins';
import { mq } from '~/styles/grid';
import CTA from '../CTA';

const BlockBodyScroll = createGlobalStyle`
body {
    ${(props) =>
      props.isOpen &&
      css`
        overflow-y: hidden;
        pointer-events: none;
      `} 
}
`;

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99998;
  background-color: #00000080;
  pointer-events: none;
  overflow: hidden;
`;

const ModalWrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 99999;
  transform: translateX(-50%) translateY(-50%);
  width: 90%;
  max-width: 700px;
  background-color: ${(props) => props.theme.color.primary800};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  pointer-events: all;
`;

const Title = styled.p`
  ${CopyBigSkin};
  color: white;
  font-size: 32px;
  text-align: center;
`;

const Content = styled.p`
  ${CopyStandardSkin}
  color: white;
  margin: 0.8rem auto;
  text-align: center;
`;

const StyledCTA = styled(CTA)`
  cursor: pointer;
  white-space: nowrap;
  a {
    min-width: 111px;
  }
`;

const CancelCTA = styled(StyledCTA)`
  background-color: white;
  a {
    color: ${(props) => props.theme.color.primary800};
  }
`;

const ActionWrapper = styled.div`
  display: flex;
  align-self: center;
  gap: 15px;
  margin-top: 1rem;

  @media (${mq.smUp}) {
    align-self: flex-end;
  }
`;

/**
 * @param {ModalProps} props
 * @returns {React.ReactElement} The rendered component
 */
const Modal = ({
  isOpen = false,
  title = '',
  content = '',
  acceptText = '',
  cancelText = '',
  onAccept,
  onCancel,
}) => {
  const intl = useIntl();
  return isOpen
    ? ReactDOM.createPortal(
        <>
          <BlockBodyScroll isOpen={isOpen} />
          <Backdrop />
          <ModalWrapper>
            <Title>{title}</Title>
            <Content>{content}</Content>
            <ActionWrapper>
              <StyledCTA
                skin="PRIMARY"
                text={
                  acceptText ||
                  intl.formatMessage({
                    id: 'modal.accept',
                  })
                }
                handleBtnClick={onAccept}
              />
              <CancelCTA
                skin="SECONDARY"
                text={
                  cancelText ||
                  intl.formatMessage({
                    id: 'modal.cancel',
                  })
                }
                handleBtnClick={onCancel}
              />
            </ActionWrapper>
          </ModalWrapper>
        </>,
        document.body,
      )
    : null;
};

export default Modal;
